// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class CustomerResponseButtonChange {
    chatId: string;
    sendButtons: boolean;  
}